import { createSlice } from "@reduxjs/toolkit";
import pillarInitialState from "@/components/PagePiller/redux/initialState";
import PillarReducer from "@/components/PagePiller/redux/reducers";

const pillarSlice = createSlice({
  name: "pillar",
  initialState: pillarInitialState,
  reducers: PillarReducer,
});

export const { setPillarData } = pillarSlice.actions;

export default pillarSlice.reducer;
